import { CreateElement } from "vue";
import { Component, Vue } from "vue-property-decorator";
import * as RecordRTC from "recordrtc";
import Card from "@/components/Card.tsx";
import AudioHandler from "./Recorder";
import { Module } from "@/store/enums.ts";
import firebase from "firebase/app";
import { storage } from "@/firebase";
import { submitFiles } from "./StorageHandler";
import UUID from "uuid/v1";
import UUID4 from "uuid/v4";

@Component
export default class TalkToMeJrSetup extends Vue {
  private _isTestComplete!: boolean;
  private _disableStartRecording!: boolean;
  private audioLoc =
    "/res/protected/t2mejr_instructions/ttmj_setup_autoplay.mp3";

  beforeCreate() {
    // Uncomment the next 3 lines when launching final deployment.
    // Commenting it out for testing purposes on Feb 21, 2019.
    if (localStorage.getItem("t2mejr-setup") === "true") {
      this.$router.push({ name: "t2mejr-tasklist" });
    }
  }

  created() {
    this._isTestComplete = false;
    this._disableStartRecording = true;

    if (localStorage.getItem("t2mejr-setup") !== "true") {
      this.$store.dispatch("setClip", {
        path: this.audioLoc,
        callbackFunction: () => {
          this._disableStartRecording = false;
          this.$forceUpdate();
        }
      });
    }
  }

  beforeDestroy() {
    if (localStorage.getItem("t2mejr-setup") !== "true") {
      this.$store.dispatch("removeClip", this.audioLoc);
    }
  }

  render(h: CreateElement) {
    return (
      <Card title="Talk2MeJr. - Setup" mod={Module.TTMJ}>
        <div slot="mainContent">
          <p class="font-weight-bold subtitle-1">
            In order to make sure that you can proceed with the test, we need to
            ensure that we can record your audio correctly.
          </p>
          <p class="font-weight-normal subtitle-2">
            <strong>Please, allow all permissions as required.</strong>
            <br />
            When you are ready, click on the button below and say:
            <br />
            `Hello, how are you? My name is Warhead. Do you wanna know the story
            of how I got my name?`
          </p>
          <v-row class="mx-auto text-center">
            <v-col cols={16}>
              <AudioHandler
                callbackOnStop={this.uponTestComplete}
                label={{
                  start: "Start Recording",
                  end: "End Recording"
                }}
                showRecorder
                recordID="setup"
                disableStartButton={this._disableStartRecording}
              />
            </v-col>
          </v-row>
          <p class="font-weight-bold subtitle-1">
            Make sure you test your microphone, and can hear yourself clearly
            before proceeding.
          </p>{" "}
        </div>

        <div slot="actions">
          <v-btn
            disabled={!this._isTestComplete}
            color="warning"
            to={{ name: "t2mejr-tasklist" }}
          >
            Next
          </v-btn>
        </div>
      </Card>
    );
  }

  async uponTestComplete(audio: any, duration: number, blob?: any) {
    if (duration > 8) duration = 8;

    setTimeout(() => {
      this._isTestComplete = true;
      localStorage.setItem("t2mejr-setup", "true");
      this.$forceUpdate();
    }, duration * 1000);

    // the below should be commented out/removed in the final version
    //   let uid = UUID();

    //   this.$store.dispatch("addNotification", {
    //     type: "info",
    //     value: "Uploading the testing data please wait",
    //     timeout: -1,
    //     icon: "mdi-microphone",
    //     uid: uid
    //   });

    //   // submit test setup files, remove later
    //   await submitFiles(
    //     "tests/setup_audio/" + UUID4() + ".webm",
    //     blob,
    //     (snapshot: any) => {
    //       let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //       this.$store.dispatch("updateVisibleNotification", {
    //         value:
    //           progress < 99
    //             ? "Please wait while we upload the testing data"
    //             : "Successfully updated",
    //         type: progress < 99 ? "info" : "success",
    //         uid: uid,
    //         loaderValue: progress,
    //         timeout: progress < 99 ? -1 : 4000
    //       });
    //     }
    //   );
  }
}

const component = TalkToMeJrSetup;
